<div class="footer">
    <div class="footer-box1">Copyright &copy; 2023 Merck & Co, Inc, Rahway, NJ, USA and its affiliates, All rights reserved.</div>
    <div class="footer-box2"></div>
    <div class="footer-box3">Merck GMSA Search Navigator</div>
  </div>